import React from 'react';

import cn from 'classnames';

import { IConDefaultType } from '../..';

export enum ResetIconVariant {
  DEFAULT = 'default',
}
export interface IResetIconProps extends IConDefaultType {
  variant?: ResetIconVariant;
}

export default function ResetIcon({
  color,
  className,
  size = 20,
  rotate,
  flip,
  variant = ResetIconVariant.DEFAULT,
}: IResetIconProps) {
  const style = {
    width: size,
    minWidth: size,
    height: size,
    transform: `rotate(${rotate}deg)`,
  };

  return (
    <i className={cn('dds-icon', className, { flip })} style={style}>
      {variant === ResetIconVariant.DEFAULT && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
          <path d="M3 5V9H7" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M5.14013 11.9996C5.57239 13.2266 6.39169 14.2798 7.47457 15.0006C8.55745 15.7214 9.84525 16.0707 11.1439 15.996C12.4426 15.9212 13.6819 15.4264 14.6749 14.5861C15.6679 13.7459 16.361 12.6056 16.6496 11.3372C16.9383 10.0688 16.8069 8.74095 16.2752 7.55371C15.7436 6.36647 14.8405 5.38417 13.702 4.75482C12.5636 4.12546 11.2514 3.88315 9.96325 4.06438C8.6751 4.24562 7.48074 4.84059 6.56013 5.75964L3.4668 8.66631"
            stroke="black"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      )}
    </i>
  );
}
